import { Crown } from 'lucide-react';
import { getCurrentYear } from '../../utils/dateUtils';

export const Footer = () => {
  return (
    <footer className="bg-charcoal-900 border-t border-gray-800 pt-16 pb-8 text-gray-400">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2 text-white">
              <Crown className="w-8 h-8 text-gold-500" />
              <span className="text-xl font-bold tracking-wider">ROYAL ROULETTE</span>
            </div>
            <p className="text-sm leading-relaxed mt-2">
              A premium interactive Roulette interface built for demonstration. Spin. Feel the thrill. Play the game — with virtual chips only.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-bold mb-4 tracking-wide text-sm">NAVIGATION</h4>
            <ul className="flex flex-col gap-3 text-sm">
              <li><a href="#home" className="hover:text-gold-500 transition-colors">Home</a></li>
              <li><a href="#roulette" className="hover:text-gold-500 transition-colors">Roulette</a></li>
              <li><a href="#features" className="hover:text-gold-500 transition-colors">Features</a></li>
              <li><a href="#how-it-works" className="hover:text-gold-500 transition-colors">How It Works</a></li>
              <li><a href="#faq" className="hover:text-gold-500 transition-colors">FAQ</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-bold mb-4 tracking-wide text-sm">LEGAL</h4>
            <ul className="flex flex-col gap-3 text-sm">
              <li><a href="#" className="hover:text-gold-500 transition-colors">Terms</a></li>
              <li><a href="#" className="hover:text-gold-500 transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-gold-500 transition-colors">Responsible Gaming</a></li>
              <li><a href="#" className="hover:text-gold-500 transition-colors">Age Restrictions</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-bold mb-4 tracking-wide text-sm">SUPPORT</h4>
            <ul className="flex flex-col gap-3 text-sm">
              <li><a href="#" className="hover:text-gold-500 transition-colors">Contact</a></li>
              <li><a href="#" className="hover:text-gold-500 transition-colors">Help Center</a></li>
              <li><a href="#" className="hover:text-gold-500 transition-colors">Support</a></li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 pt-8 text-xs text-gray-500 text-center max-w-4xl mx-auto leading-relaxed">
          <p className="mb-4">
            Royal Roulette is a non-monetary demonstration experience. There is no real-money wagering, no deposits and no withdrawals. Gambling can be addictive — play responsibly and only where legal. Strictly for users aged 18 and over.
          </p>
          <p>
            © {getCurrentYear()} Royal Roulette. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
